module.exports = __webpack_public_path__ + "static/7-bdd0aabcdec75cf6e26faf5a824d7272.png";